var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndifferent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1583_13114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3C7.03412 3 3 7.03412 3 12C3 16.9659 7.03412 21 12 21C16.9659 21 21 16.9659 21 12C21 7.03412 16.9659 3 12 3ZM12 19.9412C7.61647 19.9412 4.05882 16.3835 4.05882 12C4.05882 7.61647 7.61647 4.05882 12 4.05882C16.3835 4.05882 19.9412 7.61647 19.9412 12C19.9412 16.3835 16.3835 19.9412 12 19.9412Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2352 13.4294H7.76465C7.38347 13.4294 7.07642 13.7365 7.07642 14.1177C7.07642 14.4989 7.38347 14.8059 7.76465 14.8059H16.2352C16.6164 14.8059 16.9235 14.4989 16.9235 14.1177C16.9235 13.7365 16.6164 13.4294 16.2352 13.4294Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83406 10.9411C9.41641 10.9411 9.89288 10.4647 9.89288 9.88231C9.89288 9.29996 9.41641 8.82349 8.83406 8.82349H8.82347C8.24112 8.82349 7.76465 9.29996 7.76465 9.88231C7.76465 10.4647 8.25171 10.9411 8.83406 10.9411Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1871 10.9411C15.7694 10.9411 16.2459 10.4647 16.2459 9.88231C16.2459 9.29996 15.7694 8.82349 15.1871 8.82349H15.1765C14.5941 8.82349 14.1177 9.29996 14.1177 9.88231C14.1177 10.4647 14.6047 10.9411 15.1871 10.9411Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1583_13114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndifferent);
export default __webpack_public_path__ + "static/media/indifferent.9f1ccb00c9d4925918c587ec755e9496.svg";
export { ForwardRef as ReactComponent };